export default {
  state: {
    receiptSettings: [],
    loading: false,
  },
  getters: {
    receiptSettings: state => state.receiptSettings,
    loading: state => state.loading,
  },
  mutations: {
    setReceiptSettings(state, receiptSettings) {
      state.receiptSettings = receiptSettings;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const receiptSettings = await axios.get('api/receipt-prefixes');
        commit('setReceiptSettings', receiptSettings);
        commit('setLoading', false);
        return receiptSettings;
      } catch (e) {
        commit('setLoading', false);
      }
    },
    async fetch({ commit }, type) {
      return await axios.post(`api/receipt-prefixes/${type}`);
    },
    async update({ commit }, receiptSetting) {
      await axios.put('api/receipt-prefixes', receiptSetting);
    },
  },
};
